
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","fill":"#A0A0A0"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h40v40H0z","fill":"none"}}),_c('path',{staticClass:"74870c5a-bc9e-4740-83d9-8dbeed1fa453",attrs:{"d":"M25.5 19A8 8 0 0019 31.63C17 34.25 15.5 36 15.5 36s-11-12.4-11-20.8A11.09 11.09 0 0115.5 4a11.09 11.09 0 0111 11.2 13.78 13.78 0 01-.63 3.8zm-10-7.8a4 4 0 103.93 4 4 4 0 00-3.93-4z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M28.5 32.25L32.83 35l-1.15-5.18 3.82-3.49-5-.45-2-4.88-2 4.89-5 .45 3.82 3.49L24.17 35z"}})])
          )
        }
      }
    